import { environment } from 'src/environments/environment';

export type OzonetelDialerMode = 'sdk' | 'iframe';

function configuredMode(): OzonetelDialerMode | null {
  const mode = (environment as any).ozonetel_dialer_mode || (environment as any).ozonetel_dialer;
  return mode === 'sdk' || mode === 'iframe' ? mode : null;
}

export function getOzonetelDialerMode(): OzonetelDialerMode {
  const mode = configuredMode();
  if (mode) {
    return mode;
  }

  return (environment as any).ozonetel_sdk ? 'sdk' : 'iframe';
}

export function shouldUseOzonetelSDK(): boolean {
  const mode = configuredMode();
  if (mode) {
    return mode === 'sdk';
  }

  return (environment as any).ozonetel_sdk === true;
}

export function isOzonetelSdkDialer(): boolean {
  return getOzonetelDialerMode() === 'sdk';
}

/**
 * When true, hold/mute/unhold/unmute use CloudAgent mdlConnection.php (iframe flow)
 * instead of dc.holdCall / dc.muteCall. Requires parallel mdl session (usId, agentUniqId).
 * Set ozonetel_cloudagent_mdl: false to fall back to SDK-only controls.
 */
export function useOzonetelCloudagentMdlForControls(): boolean {
  if (!shouldUseOzonetelSDK()) {
    return false;
  }
  const flag = (environment as any).ozonetel_cloudagent_mdl;
  if (flag === false) {
    return false;
  }
  return true;
}

export function isOzonetelIframeDialer(): boolean {
  return getOzonetelDialerMode() === 'iframe';
}

/** Default SDK mode — agent receives inbound calls routed by Ozonetel. */
export const OZONETEL_INBOUND_AGENT_MODE = 'INBOUND';

/** Mode required for AgentManualDial / dc.initManualCall outbound API. */
export const OZONETEL_MANUAL_DIAL_MODE = 'MANUAL';

/**
 * SDK dialer has no Accept/Decline UI (iframe CloudAgent does).
 * When true, inbound auto-picks: toolbar tbGetCustomerData then dc.sipAccept() (SIP/WebRTC).
 */
export function shouldAutoAnswerOzonetelInbound(): boolean {
  const flag = (environment as any).ozonetel_sdk_auto_answer_inbound;
  return flag !== false;
}

/**
 * Inbound audio path when sip:true: DigitalConsole JsSIP (sipAccept).
 * OneCxi.startStreaming is outbound-only and must not run on inbound for those agents.
 */
export function useDigitalConsoleSipForInboundAudio(): boolean {
  const flag = (environment as any).ozonetel_inbound_dc_sip_audio;
  return flag !== false;
}

/**
 * Step 1 of SDK inbound auto-answer: server GET toolbar/getCustomerInfo (tbGetCustomerData).
 * Requires MDL hybrid (session + cookies). Disable via ozonetel_inbound_toolbar_pick: false.
 */
export function useToolbarInboundPick(): boolean {
  if (!shouldAutoAnswerOzonetelInbound()) {
    return false;
  }
  const flag = (environment as any).ozonetel_inbound_toolbar_pick;
  return flag !== false;
}
